<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="isDeletePage() ? 'Deleted Agencies' : 'Agencies'"
              ></h3>
              <template v-if="!isDeletePage()">
                <v-btn
                  v-if="can('AGENCIES.CREATE')"
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/agencies/create"
                >
                  <v-icon dark>mdi-plus</v-icon>
                </v-btn>
              </template>
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ..."
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      filter.search_keyword = null;
                      page = 1;
                      getData();
                    "
                    @keydown.enter="
                      page = 1;
                      getData();
                    "
                  />
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    clearable
                    @click:clear="(filter.is_active = null), (page = 1)"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear indeterminate color="primary" />
              </section>
              <v-simple-table
                v-else
                fixed-header
                :height="$vuetify.breakpoint.mobile ? '60vh' : '70vh'"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>Status</th>
                      <th>Agency Members</th>
                      <th>Agency ID</th>
                      <th>Agecny Name</th>
                      <th>Agency Owner Name</th>
                      <th>WhatsApp</th>
                      <th class="text-right">Actions</th>
                    </tr>
                  </thead>
                  <tbody v-if="agencies.length">
                    <tr
                      v-for="(agency, i) in agencies"
                      :key="`agency_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': agencies.length - 1 === i,
                      }"
                    >
                      <td>{{ i + 1 }}</td>
                      <td>
                        <v-tooltip bottom v-if="agency.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Agency is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="agency.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Agency is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>{{ agency.memberCount }}</td>
                      <td>{{ agency.agency_code }}</td>
                      <td>{{ agency.name }}</td>
                      <td>{{ agency.owner?.first_name || "N/A" }}</td>
                      <td>{{ agency.whatsapp_no || "-" }}</td>
                      <td class="text-right">
                        <template v-if="!isDeletePage()">
                          <v-tooltip bottom v-if="can('AGENCIES.DELETE')">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Delete_this(agency.id)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this Agency</span>
                          </v-tooltip>
                          <v-tooltip bottom v-if="can('AGENCIES.UPDATE')">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/agencies/${encryptIt(agency.id)}`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this Agency</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/agecncies/${encryptIt(
                                  agency.id
                                )}/agency-users`"
                              >
                                <v-icon dark>mdi-content-duplicate</v-icon>
                              </v-btn>
                            </template>
                            <span>View Agency Members</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-btn
                            fab
                            x-small
                            color="success"
                            @click="restoreAgency(agency.id)"
                          >
                            <v-icon dark>mdi-delete-restore</v-icon>
                          </v-btn>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="6" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <v-pagination rounded v-model="page" :length="paginationLength" />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-dialog v-model="is_deleted_dialog" width="500">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon style="color: green; font-size: 90px"
                  >mdi-delete-empty</v-icon
                >
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <h1 style="color: green">Deleted!</h1>
                  <h3>Agency deleted successfully.</h3>
                  <v-btn color="success" @click="is_deleted_dialog = false"
                    >OK</v-btn
                  >
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "AgenciesPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: null,
      },
      agencies: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      isLoading: false,
      is_deleted_dialog: false,
      delete_banner: false,
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`agencies?${query}`)
        .then((response) => {
          this.agencies = response.data.data;
          this.agencies = this.agencies.map((agency) => {
            return {
              ...agency,
              memberCount: agency.agency_members
                ? agency.agency_members.length
                : 0,
            };
          });
          console.log("agencies", this.agencies);

          console.log("countMember", this.countMember);

          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
    //Generate Excel
    async generateExcel() {
      let query = "search_keyword=" + this.filter.search_keyword;
      let response = await axios.get(`banner_exports?${query}`);
      console.log(response.data.data);
      if (response) {
        window.open(`${response.data.data}`, "_blank");
      }
    },
    async Delete_this(id) {
      this.delete_banner = true;
      await axios
        .post(`/agencies/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_banner = false;
          this.is_deleted_dialog = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
  },
};
</script>
